import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui-kit/card';
import { getPng } from '@/modules/gpt-chats/constants';
import { ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui-kit/button';
import { IProvider } from '@/modules/gpt-chats/types/aimodel.service.type';
import { getProviderConfig, formatProviderName } from '@/modules/gpt-chats/utils/model-selector';
import {
  getProviderDisplayName,
  ProviderType,
  PROVIDER_LOGOS,
} from '@/modules/gpt-chats/utils/aimodel-provider.utils';

import { useTranslation } from 'react-i18next';

export const ProviderCard = (provider: IProvider) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const providerKey = provider.Provider.toLowerCase();
  const logoSrc = PROVIDER_LOGOS[providerKey] || getPng(providerKey);

  const modelClickHandler = () => {
    navigate(`/ai/models/${provider.Provider}`);
  };

  return (
    <Card
      // className="w-75 group flex cursor-pointer flex-col items-start gap-4 px-4 py-5"
      className="w-75 group flex cursor-pointer flex-col items-start rounded-md transition hover:bg-accent hover:shadow-sm"
      onClick={modelClickHandler}
    >
      <CardHeader className="mb-0 flex w-[100%] flex-row justify-between">
        <div className="flex flex-row">
          <div
            className={`mr-4 flex h-12 w-12 items-center justify-center rounded-sm border p-${logoSrc ? '0' : '2'}`}
          >
            {logoSrc ? (
              <img
                src={logoSrc}
                alt={provider.Provider}
                width={64}
                height={64}
                className="object-contain"
              />
            ) : (
              (() => {
                const ProviderIcon = getProviderConfig(formatProviderName(provider.Provider)).icon;
                return <ProviderIcon className="aspect-square w-8" />;
              })()
            )}
          </div>

          <div className="flex flex-col">
            <CardTitle className="text-lg font-semibold text-high-emphasis">
              {getProviderDisplayName(provider.Provider)}
            </CardTitle>
            <p className="text-sm font-light text-low-emphasis">
              {provider.Provider.toLowerCase() === ProviderType.CUSTOM
                ? t('MY_MODEL')
                : t('MY_KEY')}
            </p>
          </div>
        </div>

        <Button
          variant="ghost"
          size="icon"
          className="p-0 opacity-0 transition-opacity duration-150 group-hover:opacity-100"
          onClick={modelClickHandler}
        >
          <ChevronRight className="aspect-square w-5" />
        </Button>
      </CardHeader>
      <CardContent>
        <p className="font-dm line-clamp-3 font-normal text-medium-emphasis">
          {provider.Description}
        </p>
      </CardContent>
    </Card>
  );
};
